import React, { useContext, useEffect, useState } from "react";
import { Eye } from "lucide-react";
import { UrlContext } from "../../contexts/UrlContext";

const PageViewCounter = ({ project }) => {
  const { API_URL } = useContext(UrlContext);

  const [visitCount, setVisitCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!project) {
      setLoading(false);
      return;
    }

    const fetchAnalyticsData = async () => {
      setLoading(true);

      try {
        const response = await fetch(`${API_URL}client-views/${project}`);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setVisitCount(data.count ?? 0);
      } catch (error) {
        console.error("Error fetching analytics data:", error);
        setVisitCount(0);
      } finally {
        setLoading(false);
      }
    };

    fetchAnalyticsData();
  }, [API_URL, project]);

  return (
    <div
      className="relative inline-flex shrink-0"
      title={`${visitCount} client ${visitCount === 1 ? "view" : "views"}`}
    >
      <div className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#365561]/10 text-[#365561] transition hover:bg-[#365561]/20">
        <Eye className="h-4 w-4" strokeWidth={2} />
      </div>

      <span
        className={[
          "absolute -right-1.5 -top-1.5 flex min-h-4 min-w-4 items-center justify-center",
          "rounded-full bg-[#365561] px-1 text-[9px] font-semibold leading-none text-white",
          "ring-2 ring-white",
          loading ? "animate-pulse" : "",
        ].join(" ")}
      >
        {loading ? "…" : visitCount > 99 ? "99+" : visitCount}
      </span>
    </div>
  );
};

export default PageViewCounter;